/**
 * The coverage limit a merchant sees in the goods warning.
 *
 * Merchants can have their own limit (merchant setup, Mike 6-oct). When they do,
 * it replaces the category limit without a code, and the warning has to say
 * their number, not the generic one. General goods never go above the category
 * maximum with a code (5,000), setup or not. Without a setup, the text is the
 * same as before.
 */
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmt = (n) => Number(n).toLocaleString();

export async function cargarMiSetup(token) {
  if (!token) return null;
  try {
    const r = await fetch(`${API}/merchants/me/setup`, { headers: { Authorization: `Bearer ${token}` } });
    return r.ok ? await r.json() : null;
  } catch (e) {
    return null;
  }
}

export function avisoTope(cat, setup, telefono) {
  if (!cat) return null;
  const limite = setup?.coverage_limit;
  if (limite) {
    const sinCodigo = cat.max_with_code ? Math.min(limite, cat.max_with_code) : limite;
    return `Your account covers ${cat.label} up to $${fmt(sinCodigo)} without a code. Above that, call the office at ${telefono}.`;
  }
  if (!cat.max_without_code) return null;
  return cat.max_with_code
    ? `${cat.label} are covered up to $${fmt(cat.max_without_code)} without a code, and up to $${fmt(cat.max_with_code)} with an approval code from the office at ${telefono}.`
    : `${cat.label} are covered up to $${fmt(cat.max_without_code)} without a code. Above that, call the office at ${telefono}.`;
}
